import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function Enigme() {
  return (
    <PanelContent
      id="enigme_panel"
      route="/enigme"
      frTitle = "L’énigme"
      enTitle = "The Mystery"
      frSubtitle = "Un enlèvement suspect"
      enSubtitle = "A Suspicious Kidnapping"
      frText = "En janvier 1976, un enfant est enlevé avec une demande de rançon de 1 million de francs. L'échange doit avoir lieu devant un restaurant Aubois et la voiture de Patrick Henry y est repérée. Cependant, il nie toute implication et réclame même la peine de mort pour le criminel. Plus tard, l'enfant est retrouvé mort dans une chambre d'hôtel louée par Patrick Henry."
      enText = "In January 1976, a child was kidnapped with a ransom demand of 1 million francs. The exchange was to take place in front of a restaurant in Aubois, and Patrick Henry's car was spotted there. However, he denied any involvement and even called for the death penalty for the criminal. Later, the child was found dead in a hotel room rented by Patrick Henry."
      frLeftButton=""
      enLeftButton = ""
      frRightButton="ÉTAPE SUIVANTE"
      enRightButton = "NEXT STEP"
      prev="/context"
      next="/avocats"
    />
  );
}
